import { useState } from "react";
import { Button } from "react-bootstrap";
import Calendly from "./Calendly";

function BookMeeting() {
  const [activeMeeting, setActiveMeeting] = useState(null);

  return (
    <div
      className="scrollable-container"
      style={{
        height: "100%",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <h1>
          <strong>Schedule a Meeting</strong>
        </h1>

        {/* Buttons Row */}
        <div style={{ display: "flex", gap: "20px" }}>
          {/* <Button
            onClick={() =>
              setActiveMeeting(
                activeMeeting === "oneToOne" ? null : "oneToOne"
              )
            }
          >
            Schedule 1-to-1 Meeting
          </Button> */}

          <Button
            variant="success"
            onClick={() =>
              setActiveMeeting(
                activeMeeting === "group" ? null : "group"
              )
            }
          >
            Schedule A Demo
          </Button>
        </div>

        {/* Calendly Section */}
        {activeMeeting && (
          <div
            style={{
              width: "100%",
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Calendly type={activeMeeting} />
          </div>
        )}
      </div>
    </div>
  );
}

export default BookMeeting;
